import React from 'react'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Typography,
} from '@mui/material'
import { usePageTitle } from '../../../components/common/PageTitleContext'
import useUserSettingsStore from '../../../store/userSettings'

const ShowClockSettingsPage: React.FC = () => {
  usePageTitle('Show Clock settings')

  const livePrepTease = useUserSettingsStore((state) => state.showClock.livePrepTease)
  const setLivePrepTease = useUserSettingsStore((state) => state.setShowClockLivePrepTease)
  const liveHeaderVisible = useUserSettingsStore((state) => state.showClock.liveHeaderVisible)
  const setLiveHeaderVisible = useUserSettingsStore((state) => state.setShowClockLiveHeaderVisible)
  const liveHeaderFill = useUserSettingsStore((state) => state.showClock.liveHeaderFill)
  const setLiveHeaderFill = useUserSettingsStore((state) => state.setShowClockLiveHeaderFill)
  const liveTheme = useUserSettingsStore((state) => state.showClock.liveTheme)
  const setLiveTheme = useUserSettingsStore((state) => state.setShowClockLiveTheme)

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="h5" component="h2">
          Show Clock
        </Typography>
        <Typography color="text.secondary">
          Preferences for the live show clock view.
        </Typography>
      </Stack>

      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
        <Stack spacing={1}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Live view
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={livePrepTease}
                onChange={(event) => setLivePrepTease(event.target.checked)}
                inputProps={{ 'aria-label': 'Show prep tease in live show clock' }}
              />
            }
            label="Show prep item tease text"
          />
          <Typography variant="body2" color="text.secondary">
            Turn on to show the extra prep text below each attached prep item.
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={liveHeaderVisible}
                onChange={(event) => setLiveHeaderVisible(event.target.checked)}
                inputProps={{ 'aria-label': 'Show live show clock header bar' }}
              />
            }
            label="Show live header bar"
          />
          <Typography variant="body2" color="text.secondary">
            Toggle the live view header bar on or off.
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={liveHeaderFill}
                onChange={(event) => setLiveHeaderFill(event.target.checked)}
                inputProps={{ 'aria-label': 'Use header bar fill for countdown progress' }}
              />
            }
            label="Use header bar as countdown progress"
          />
          <Typography variant="body2" color="text.secondary">
            When enabled, the header bar background shows countdown progress. When disabled, a separate progress bar is shown.
          </Typography>
          <FormControl component="fieldset">
            <FormLabel component="legend">Live view theme override</FormLabel>
            <RadioGroup
              row
              value={liveTheme}
              onChange={(event) => setLiveTheme(event.target.value as typeof liveTheme)}
              aria-label="Live show clock theme override"
            >
              <FormControlLabel value="inherit" control={<Radio />} label="Use app theme" />
              <FormControlLabel value="light" control={<Radio />} label="Light" />
              <FormControlLabel value="dark" control={<Radio />} label="Dark" />
            </RadioGroup>
            <Typography variant="body2" color="text.secondary">
              Overrides the theme inside the live show clock pane only.
            </Typography>
          </FormControl>
        </Stack>
      </Paper>
    </Stack>
  )
}

export default ShowClockSettingsPage
